import { FeatureFlags } from 'featureFlags/constants';
import { useFeatureFlag } from 'shared/hooks/useFeatureFlag';
import { useStoreSelector } from 'store/hooks/storeHooks';

export const useIsBannerVisible = () => {
  const isBannerEnabled = useFeatureFlag(FeatureFlags.WEB_ENABLE_GOAT_BANNER);
  const { title, subtitle } = useStoreSelector((state) => state.cmsBanner);

  return isBannerEnabled && !!(title || subtitle);
};
